var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('a-authorization-card',{staticClass:"ma-5",attrs:{"color":"secondary","icon":"mdi-logout","title":"Fin de session","text":"Vous êtes déconnecté de l'application."}},[_c('p',[_c('router-link',{attrs:{"to":"/accueil"}},[_vm._v("Cliquer ici")]),_vm._v(" pour vous reconnecter. ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }